import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NO_VALUE } from '@pipes';
import { InstallationFeaturesStore, WallboxChargingSubstatus } from '@store';
import {
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsNumberValueProperty,
  IsStringValueProperty,
  WallboxSessionCharging,
  WallboxSubstatus,
} from '@vi-iot/client';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SUFFIX } from 'src/app/shared/common/units';

@Component({
  selector: 'app-wallbox-system-overlay',
  templateUrl: './wallbox-system-overlay.component.html',
  styleUrls: ['./wallbox-system-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WallboxSystemOverlayComponent implements OnInit {
  readonly SUFFIX = SUFFIX;
  readonly featurePropertyKey = FeaturePropertyKey;

  deviceThirdpartyManufacturer$: Observable<Feature<IsStringValueProperty, never>>;
  deviceThirdpartyModel$: Observable<Feature<IsStringValueProperty, never>>;
  deviceThirdpartySoftware$: Observable<Feature<IsStringValueProperty, never>>;
  deviceEtn$: Observable<Feature<IsStringValueProperty, never>>;
  chargingPower$: Observable<Feature<IsNumberValueProperty, never>>;
  displayedStatus$: Observable<Feature<WallboxSubstatus, any>>; // not present in wiki
  sessionCharging$: Observable<Feature<WallboxSessionCharging, never>>;

  displayedStatus: string;
  displayedStatusDescription: string;
  FeatureNames = FeatureNames;
  constructor(
    private installationFeaturesStore: InstallationFeaturesStore,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.deviceThirdpartyManufacturer$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceThirdpartyManufacturer
    );
    this.deviceThirdpartyModel$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceThirdpartyModel
    );
    this.deviceThirdpartySoftware$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceThirdpartySoftware
    );
    this.deviceEtn$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceEtn
    );
    this.chargingPower$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.wallboxDisplayedPower
    );
    this.displayedStatus$ = this.installationFeaturesStore
      .selectInstallationDeviceFeature<WallboxSubstatus, any>(
        FeatureNames.wallboxDisplayedSubstatus
      )
      .pipe(
        tap((feature) => {
          this.setDisplayStatusLabels(feature?.properties?.substatus?.value);
        })
      );
    this.sessionCharging$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.wallboxSessionCharging
    );
  }

  private setDisplayStatusLabels(status: WallboxChargingSubstatus | string): void {
    switch (status) {
      case WallboxChargingSubstatus.CHARGING_WITH_REDUCED_POWER:
        this.displayedStatus = '+INSTALLATIONS.INSTALLATION.WALLBOX.CHARGING_CHARGING';
        this.displayedStatusDescription = `(${this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.WALLBOX.CHARGING.CHARGING_WITH_REDUCED_POWER'
        )})`;
        break;

      case WallboxChargingSubstatus.OVERLOAD_PROTECTION_ACTIVE:
        this.displayedStatus = '+INSTALLATIONS.INSTALLATION.WALLBOX.CHARGING_CHARGING';
        this.displayedStatusDescription = `(${this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.WALLBOX.CHARGING.OVERLOAD_PROTECTION_ACTIVE'
        )})`;
        break;

      case WallboxChargingSubstatus.PV_EXCESS_NOT_SUFFICIENT:
        this.displayedStatus = '+INSTALLATIONS.INSTALLATION.WALLBOX.NOT_CHARGING';
        this.displayedStatusDescription = `(${this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.WALLBOX.CHARGING.PV_EXCESS_NOT_SUFFICIENT'
        )})`;
        break;
      default:
        this.displayedStatus = NO_VALUE;
    }
  }
}
